import * as AppConstants from 'app/AppConstants';
import {BUZZ_MENU_ITEMS} from 'handlers/Buzz/BuzzMenuHandler/components/BuzzMenuConstants';

export const initialState = () => ({
  lastRoute: BUZZ_MENU_ITEMS.FAVORITES,
  lastInboxRoute: BUZZ_MENU_ITEMS.FAVORITES,
  isLoaded: false,
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.BUZZ__CHANGED_BUZZ_ROUTE:
      return {
        ...state,
        lastRoute: action.payload.lastRoute,
        isLoaded: true,
      };
    case AppConstants.BUZZ__CHANGED_BUZZ_INBOX_ROUTE:
      return {
        ...state,
        lastRoute: action.payload.lastRoute,
        lastInboxRoute: action.payload.lastRoute,
        isLoaded: true,
      };
    case AppConstants.BUZZ__LOAD_ROUTE:
      return {
        ...state,
        lastRoute: action.payload.lastRoute,
        lastInboxRoute: action.payload.lastInboxRoute,
        isLoaded: true,
      };

    default:
      return state;
  }
};
